module.exports = {
  generate: function() {
    var dateNum, msSinceEpoch, randNum, x;
    x = 2147483648;
    randNum = Math.floor(Math.random() * x);
    msSinceEpoch = new Date().getTime();
    dateNum = Math.abs(Math.floor(Math.random() * x) ^ msSinceEpoch);
    return randNum.toString(36) + dateNum.toString(36);
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL2xpYi9JZEdlbmVyYXRvci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvd29yay9zcmMvbGliL0lkR2VuZXJhdG9yLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixRQUFBLEVBQVUsU0FBQTtBQUNULFFBQUE7SUFBQSxDQUFBLEdBQUk7SUFDSixPQUFBLEdBQVUsSUFBSSxDQUFDLEtBQUwsQ0FBVyxJQUFJLENBQUMsTUFBTCxDQUFBLENBQUEsR0FBZ0IsQ0FBM0I7SUFDVixZQUFBLEdBQWUsSUFBSSxJQUFKLENBQUEsQ0FBVSxDQUFDLE9BQVgsQ0FBQTtJQUNmLE9BQUEsR0FBVSxJQUFJLENBQUMsR0FBTCxDQUFTLElBQUksQ0FBQyxLQUFMLENBQVcsSUFBSSxDQUFDLE1BQUwsQ0FBQSxDQUFBLEdBQWdCLENBQTNCLENBQUEsR0FBZ0MsWUFBekM7V0FDVixPQUFPLENBQUMsUUFBUixDQUFpQixFQUFqQixDQUFBLEdBQXVCLE9BQU8sQ0FBQyxRQUFSLENBQWlCLEVBQWpCO0VBTGQsQ0FETSJ9
